import * as React from 'react';
import { SVGProps } from 'react';

const MedalIcon = (props: SVGProps<SVGSVGElement>): JSX.Element => (
  <svg
    {...props}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
    fill="none"
  >
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="M20 36.667V35M9.48 33.85l1.034-1.034M32.5 23.333h1.667M5.832 23.333h1.667M29.48 32.816l1.034 1.034M24.91 18.422a6.945 6.945 0 1 1-9.821 9.821 6.945 6.945 0 0 1 9.821-9.821ZM27.384 10H12.617"
    />
    <path
      stroke="#323232"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth={2}
      d="m26.124 20.13 6.36-7.13c.545-.61.847-1.4.847-2.219V6.666c0-1.833-1.5-3.333-3.334-3.333h-20a3.332 3.332 0 0 0-3.333 3.333v4.115c0 .819.302 1.609.847 2.219l6.36 7.13M7.617 4.383l10.85 12.183M32.381 4.383l-10.85 12.183"
    />
  </svg>
);
export default MedalIcon;
